import { PaymentMethod } from "../../../types/payment"
import { CreditCard, Check } from "lucide-react"

interface PaymentMethodListProps {
  paymentMethods: PaymentMethod[]
  onRemove: (id: string) => void
  onSetDefault: (id: string) => void
  isLoading?: boolean
}

const PaymentMethodList = ({
  paymentMethods,
  onRemove,
  onSetDefault,
  isLoading = false
}: PaymentMethodListProps) => {
  const getBrandIcon = (brand: string) => {
    return <CreditCard className="h-8 w-8" />
  }

  if (paymentMethods.length === 0) {
    return (
      <div className="text-center py-12">
        <CreditCard className="mx-auto h-12 w-12 text-gray-400 mb-4" />
        <p className="text-gray-500 text-lg mb-2">No payment methods on file</p>
        <p className="text-gray-400 text-sm">
          Click "Add Payment Method" above to add your first card
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {paymentMethods.map(pm => (
        <div
          key={pm.id}
          className="border rounded-lg p-4 flex items-center justify-between"
        >
          <div className="flex items-center space-x-4">
            {getBrandIcon(pm.card.brand)}
            <div>
              <div className="flex items-center space-x-2">
                <span className="font-medium capitalize">{pm.card.brand}</span>
                <span>•••• {pm.card.last4}</span>
                {pm.is_default && (
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    <Check className="h-3 w-3 mr-1" />
                    Default
                  </span>
                )}
              </div>
              <div className="text-sm text-gray-500">
                Expires {pm.card.exp_month}/{pm.card.exp_year}
              </div>
            </div>
          </div>

          <div className="flex space-x-2">
            {!pm.is_default && (
              <button
                onClick={() => onSetDefault(pm.id)}
                disabled={isLoading}
                className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50"
              >
                Set as Default
              </button>
            )}
            <button
              onClick={() => onRemove(pm.id)}
              disabled={isLoading || pm.is_default}
              className="px-3 py-1 text-sm text-red-600 border border-red-300 rounded hover:bg-red-50 disabled:opacity-50"
            >
              Remove
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}

export default PaymentMethodList
